import { Platform } from '@angular/cdk/platform';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  currentUser: any;
  currentUserData: any;
  dropdownPosition: string = 'bottom-right'
  dropdownContainer: string = ''

  constructor(
    private toastr: ToastrService,
    private router: Router,
    public platform: Platform
  ) { 
    if(this.platform.ANDROID || this.platform.IOS) {
      this.dropdownContainer = 'body'
    }
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('responseData'));
    this.currentUserData = JSON.parse(localStorage.getItem('userDetails'));
  }
  signout(currentUser) {
    localStorage.clear();
    console.log(currentUser);
    this.toastr.success('Sign Out Successfully');
    this.router.navigate(['']);
  }
}
